/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ListStorageActionsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * StorageActionsAPIApi - axios parameter creator
 * @export
 */
export const StorageActionsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns storage actions for a cluster within a time range.
         * @summary Returns storage actions for a cluster within a time range.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {Array<string>} [filterActionNames] Filter by action names (e.g. \&quot;resize-disk\&quot;, \&quot;add-cloud-disk\&quot;). If empty, all actions are included.
         * @param {Array<string>} [filterStatuses] Filter by status (e.g. \&quot;success\&quot;, \&quot;failed\&quot;). If empty, all statuses are included.
         * @param {Array<string>} [filterNodeNames] Filter by node names. If empty, all nodes are included.
         * @param {Array<string>} [filterPersistentVolumeNames] Filter by persistent volume names. If empty, all volumes are included.
         * @param {StorageActionsAPIListStorageActionsFilterStorageTypeEnum} [filterStorageType] Filter by storage type (persistent or ephemeral). If unspecified, all types are included.
         * @param {Array<string>} [filterNamespaces] Filter by namespaces. If empty, all namespaces are included. Only persistent  storage actions have a namespace; when this filter is set, actions without a  namespace (ephemeral storage) are excluded.
         * @param {Array<StorageActionsAPIListStorageActionsFilterReasonCodesEnum>} [filterReasonCodes] Filter by scaling reason codes. Matches actions whose reasons contain any of  the given codes. If empty, all actions are included.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storageActionsAPIListStorageActions: async (organizationId: string, clusterId: string, startTime?: string, endTime?: string, filterActionNames?: Array<string>, filterStatuses?: Array<string>, filterNodeNames?: Array<string>, filterPersistentVolumeNames?: Array<string>, filterStorageType?: StorageActionsAPIListStorageActionsFilterStorageTypeEnum, filterNamespaces?: Array<string>, filterReasonCodes?: Array<StorageActionsAPIListStorageActionsFilterReasonCodesEnum>, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('storageActionsAPIListStorageActions', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('storageActionsAPIListStorageActions', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/storage-action-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (filterActionNames) {
                localVarQueryParameter['filter.actionNames'] = filterActionNames;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterNodeNames) {
                localVarQueryParameter['filter.nodeNames'] = filterNodeNames;
            }

            if (filterPersistentVolumeNames) {
                localVarQueryParameter['filter.persistentVolumeNames'] = filterPersistentVolumeNames;
            }

            if (filterStorageType !== undefined) {
                localVarQueryParameter['filter.storageType'] = filterStorageType;
            }

            if (filterNamespaces) {
                localVarQueryParameter['filter.namespaces'] = filterNamespaces;
            }

            if (filterReasonCodes) {
                localVarQueryParameter['filter.reasonCodes'] = filterReasonCodes;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorageActionsAPIApi - functional programming interface
 * @export
 */
export const StorageActionsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorageActionsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns storage actions for a cluster within a time range.
         * @summary Returns storage actions for a cluster within a time range.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {Array<string>} [filterActionNames] Filter by action names (e.g. \&quot;resize-disk\&quot;, \&quot;add-cloud-disk\&quot;). If empty, all actions are included.
         * @param {Array<string>} [filterStatuses] Filter by status (e.g. \&quot;success\&quot;, \&quot;failed\&quot;). If empty, all statuses are included.
         * @param {Array<string>} [filterNodeNames] Filter by node names. If empty, all nodes are included.
         * @param {Array<string>} [filterPersistentVolumeNames] Filter by persistent volume names. If empty, all volumes are included.
         * @param {StorageActionsAPIListStorageActionsFilterStorageTypeEnum} [filterStorageType] Filter by storage type (persistent or ephemeral). If unspecified, all types are included.
         * @param {Array<string>} [filterNamespaces] Filter by namespaces. If empty, all namespaces are included. Only persistent  storage actions have a namespace; when this filter is set, actions without a  namespace (ephemeral storage) are excluded.
         * @param {Array<StorageActionsAPIListStorageActionsFilterReasonCodesEnum>} [filterReasonCodes] Filter by scaling reason codes. Matches actions whose reasons contain any of  the given codes. If empty, all actions are included.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storageActionsAPIListStorageActions(organizationId: string, clusterId: string, startTime?: string, endTime?: string, filterActionNames?: Array<string>, filterStatuses?: Array<string>, filterNodeNames?: Array<string>, filterPersistentVolumeNames?: Array<string>, filterStorageType?: StorageActionsAPIListStorageActionsFilterStorageTypeEnum, filterNamespaces?: Array<string>, filterReasonCodes?: Array<StorageActionsAPIListStorageActionsFilterReasonCodesEnum>, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListStorageActionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storageActionsAPIListStorageActions(organizationId, clusterId, startTime, endTime, filterActionNames, filterStatuses, filterNodeNames, filterPersistentVolumeNames, filterStorageType, filterNamespaces, filterReasonCodes, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageActionsAPIApi.storageActionsAPIListStorageActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StorageActionsAPIApi - factory interface
 * @export
 */
export const StorageActionsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorageActionsAPIApiFp(configuration)
    return {
        /**
         * Returns storage actions for a cluster within a time range.
         * @summary Returns storage actions for a cluster within a time range.
         * @param {StorageActionsAPIApiStorageActionsAPIListStorageActionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storageActionsAPIListStorageActions(requestParameters: StorageActionsAPIApiStorageActionsAPIListStorageActionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListStorageActionsResponse> {
            return localVarFp.storageActionsAPIListStorageActions(requestParameters.organizationId, requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, requestParameters.filterActionNames, requestParameters.filterStatuses, requestParameters.filterNodeNames, requestParameters.filterPersistentVolumeNames, requestParameters.filterStorageType, requestParameters.filterNamespaces, requestParameters.filterReasonCodes, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for storageActionsAPIListStorageActions operation in StorageActionsAPIApi.
 * @export
 * @interface StorageActionsAPIApiStorageActionsAPIListStorageActionsRequest
 */
export interface StorageActionsAPIApiStorageActionsAPIListStorageActionsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly clusterId: string

    /**
     * Start time of the reporting period (inclusive).
     * @type {string}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly startTime?: string

    /**
     * End time of the reporting period (exclusive).
     * @type {string}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly endTime?: string

    /**
     * Filter by action names (e.g. \&quot;resize-disk\&quot;, \&quot;add-cloud-disk\&quot;). If empty, all actions are included.
     * @type {Array<string>}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly filterActionNames?: Array<string>

    /**
     * Filter by status (e.g. \&quot;success\&quot;, \&quot;failed\&quot;). If empty, all statuses are included.
     * @type {Array<string>}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly filterStatuses?: Array<string>

    /**
     * Filter by node names. If empty, all nodes are included.
     * @type {Array<string>}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly filterNodeNames?: Array<string>

    /**
     * Filter by persistent volume names. If empty, all volumes are included.
     * @type {Array<string>}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly filterPersistentVolumeNames?: Array<string>

    /**
     * Filter by storage type (persistent or ephemeral). If unspecified, all types are included.
     * @type {'STORAGE_TYPE_UNSPECIFIED' | 'PERSISTENT' | 'EPHEMERAL'}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly filterStorageType?: StorageActionsAPIListStorageActionsFilterStorageTypeEnum

    /**
     * Filter by namespaces. If empty, all namespaces are included. Only persistent  storage actions have a namespace; when this filter is set, actions without a  namespace (ephemeral storage) are excluded.
     * @type {Array<string>}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly filterNamespaces?: Array<string>

    /**
     * Filter by scaling reason codes. Matches actions whose reasons contain any of  the given codes. If empty, all actions are included.
     * @type {Array<'SCALING_REASON_CODE_UNSPECIFIED' | 'IOPS_SATURATION' | 'IOPS_UNDERUTILIZED' | 'THROUGHPUT_SATURATION' | 'THROUGHPUT_UNDERUTILIZED' | 'LOW_FREE_SPACE' | 'PREEMPTIVE_SIZE_HEADROOM'>}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly filterReasonCodes?: Array<StorageActionsAPIListStorageActionsFilterReasonCodesEnum>

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof StorageActionsAPIApiStorageActionsAPIListStorageActions
     */
    readonly pageCursor?: string
}

/**
 * StorageActionsAPIApi - object-oriented interface
 * @export
 * @class StorageActionsAPIApi
 * @extends {BaseAPI}
 */
export class StorageActionsAPIApi extends BaseAPI {
    /**
     * Returns storage actions for a cluster within a time range.
     * @summary Returns storage actions for a cluster within a time range.
     * @param {StorageActionsAPIApiStorageActionsAPIListStorageActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageActionsAPIApi
     */
    public storageActionsAPIListStorageActions(requestParameters: StorageActionsAPIApiStorageActionsAPIListStorageActionsRequest, options?: RawAxiosRequestConfig) {
        return StorageActionsAPIApiFp(this.configuration).storageActionsAPIListStorageActions(requestParameters.organizationId, requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, requestParameters.filterActionNames, requestParameters.filterStatuses, requestParameters.filterNodeNames, requestParameters.filterPersistentVolumeNames, requestParameters.filterStorageType, requestParameters.filterNamespaces, requestParameters.filterReasonCodes, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const StorageActionsAPIListStorageActionsFilterStorageTypeEnum = {
    STORAGE_TYPE_UNSPECIFIED: 'STORAGE_TYPE_UNSPECIFIED',
    PERSISTENT: 'PERSISTENT',
    EPHEMERAL: 'EPHEMERAL'
} as const;
export type StorageActionsAPIListStorageActionsFilterStorageTypeEnum = typeof StorageActionsAPIListStorageActionsFilterStorageTypeEnum[keyof typeof StorageActionsAPIListStorageActionsFilterStorageTypeEnum];
/**
 * @export
 */
export const StorageActionsAPIListStorageActionsFilterReasonCodesEnum = {
    SCALING_REASON_CODE_UNSPECIFIED: 'SCALING_REASON_CODE_UNSPECIFIED',
    IOPS_SATURATION: 'IOPS_SATURATION',
    IOPS_UNDERUTILIZED: 'IOPS_UNDERUTILIZED',
    THROUGHPUT_SATURATION: 'THROUGHPUT_SATURATION',
    THROUGHPUT_UNDERUTILIZED: 'THROUGHPUT_UNDERUTILIZED',
    LOW_FREE_SPACE: 'LOW_FREE_SPACE',
    PREEMPTIVE_SIZE_HEADROOM: 'PREEMPTIVE_SIZE_HEADROOM'
} as const;
export type StorageActionsAPIListStorageActionsFilterReasonCodesEnum = typeof StorageActionsAPIListStorageActionsFilterReasonCodesEnum[keyof typeof StorageActionsAPIListStorageActionsFilterReasonCodesEnum];
